import * as PropTypes from 'prop-types'
import classNames from 'classnames'
import photoStyles from './Photo.css'

export class Photo extends React.PureComponent {
  static propTypes = {
    alt: PropTypes.string,
    fillsParent: PropTypes.bool,
    backgroundSize: PropTypes.string,
    backgroundPosition: PropTypes.string,
    isFullWidth: PropTypes.bool,
    isSemiTransparent: PropTypes.bool,
    src: PropTypes.string.isRequired,
    srcSet: PropTypes.string
  }

  static defaultProps = {
    alt: 'photo',
    backgroundPosition: 'center center'
  }

  state = {
    loadedSrc: null,
    isLoaded: false
  }

  photoRef = React.createRef()

  // The currentSrc property is set by the srcset attribute when it loads the corresponding image.
  // Reading this property allows us to have responsive background images.
  setLoadedSrc = () => {
    this.setState(() => {
      const photoRef = this.photoRef.current
      const currentSrc = photoRef.currentSrc

      return {
        isLoaded: true,
        loadedSrc: currentSrc ? currentSrc : photoRef.src
      }
    })
  }

  componentDidMount () {
    const photoRef = this.photoRef.current

    if (!this.state.isLoaded && photoRef && photoRef.complete) {
      this.setLoadedSrc()
    }
  }

  render () {
    const {
      alt,
      backgroundSize,
      backgroundPosition,
      fillsParent,
      isFullWidth,
      isSemiTransparent,
      src,
      srcSet
    } = this.props

    const {
      loadedSrc
    } = this.state

    const backgroundStyleProps = {
      backgroundPosition,
      backgroundSize
    }

    const img = (
      <img
        alt={alt}
        className={classNames(
          photoStyles.photo,
          { [photoStyles.isFullWidth]: isFullWidth }
        )}
        onLoad={this.setLoadedSrc}
        ref={this.photoRef}
        src={src}
        srcSet={srcSet}
      />
    )

    if (fillsParent && loadedSrc) {
      backgroundStyleProps.backgroundImage = `url(${loadedSrc})`

      return (
        <div
          className={classNames(
            photoStyles.photoFillsParent,
            { [photoStyles.isSemiTransparent]: isSemiTransparent }
          )}
          style={{...backgroundStyleProps}}>
          {img}
        </div>
      )
    }

    return img
  }
}
